import { FieldHtmlNameUtil } from 'www-shared';
import {
  toRefs,
  watch,
} from 'vue';
import TrackingUtil from '../../../../../util/TrackingUtil';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import AbstractSubmitSignupScreen from './AbstractSubmitSignupScreen';

export default class FreeDetail2SignupScreen extends AbstractSubmitSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-free-2of2';

  public getThisScreensVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.doYouUseCadAtWork),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.companyName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.jobTitle),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howDidYouHearAboutUs),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.tosConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.privacyConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.recaptcha),
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents().filter((cmp) => cmp.displayField.htmlName !== FieldHtmlNameUtil.recaptcha);
  }

  public predicate(): boolean {
    const { chosenPlan, completedDetailsScreens, formSubmitStatus } = this.sessionInfo.value;
    if (formSubmitStatus !== null && formSubmitStatus !== 'submit-failed') {
      return false;
    }
    if (chosenPlan === null || !chosenPlan.compareTo(UnifiedSignupPlan.free)) {
      return false;
    }

    if (completedDetailsScreens.length !== 1) {
      return false;
    }

    return true;
  }

  public async initWatchers(): Promise<void> {
    const cadAtWorkField = this.getField(FieldHtmlNameUtil.doYouUseCadAtWork);
    const companyNameField = this.getField(FieldHtmlNameUtil.companyName);
    const jobTitleField = this.getField(FieldHtmlNameUtil.jobTitle);

    const hideFields = () => {
      companyNameField.componentName = 'hidden-field';
      companyNameField.isRequired = false;
      companyNameField.val = '';
      jobTitleField.componentName = 'hidden-field';
      jobTitleField.isRequired = false;
      jobTitleField.val = '';
    };
    hideFields();
    const cadAtWorkFieldVal = toRefs(cadAtWorkField).val;

    watch(cadAtWorkFieldVal, (newVal, oldVal) => {
      if (newVal === 'no' && oldVal === 'yes') {
        TrackingUtil.mouseFlowPush(['tag', 'cadAtWorkYtoN']);
      }

      if (newVal === 'yes') {
        companyNameField.componentName = companyNameField.initialComponentName;
        companyNameField.isRequired = true;
        jobTitleField.componentName = companyNameField.initialComponentName;
        jobTitleField.isRequired = true;
      } else {
        hideFields();
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 85;
  }
}
